module.exports = __webpack_public_path__ + "static/media/status-badge-basic.b8e47768.svg";